@if (VendorReview) {
  <div class="container">
    <div class="row g-3">
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-lg-4">
            <p class="fw-semibold text-center">Customer Service</p>
          </div>
          <div class="col-12 col-lg-4">
            <p class="fw-semibold text-center">Rating</p>
          </div>
          <div class="col-12 col-lg-4">
            <p class="fw-semibold text-center">N/A</p>
          </div>
        </div>
        <hr class="mt-0" />
        @for (
          question of customerServiceRatings
            | keyvalue: keyValuePairDefaultOrder;
          track question
        ) {
          <div class="row justify-content-center align-items-start py-1">
            <div class="col-12 col-lg-4">
              <p class="text-left">{{ question.key }}</p>
            </div>
            <div class="col-12 col-lg-4">
              <app-star-rating
                [rating]="question.value.value || 0"
                [size]="14"
                [readonly]="readOnly"
                (updatedRating)="updateRating($event, question)"
              ></app-star-rating>
            </div>
            <div class="col-12 col-lg-4 d-flex flex-column align-items-center">
              <input
                type="checkbox"
                class="form-check-input"
                [disabled]="readOnly"
                (click)="onNAChange(question)"
                [checked]="question.value.na"
              />
            </div>
          </div>
        }
        @if (showOverallRatings) {
          <div class="row">
            <div class="col-12 col-lg-4">
              <p class="text-decoration-underline fw-semibold">
                Overall Customer Service Rating
              </p>
            </div>
            <div class="col-12 col-lg-4">
              <app-star-rating
                [rating]="overallCustomerServiceRatings"
                [size]="14"
              ></app-star-rating>
            </div>
          </div>
        }
      </div>
      <div class="col">
        <div class="row">
          <div class="col-12 col-lg-4">
            <p class="fw-semibold text-center">Professionalism</p>
          </div>
          <div class="col-12 col-lg-4">
            <p class="fw-semibold text-center">Rating</p>
          </div>
          <div class="col-12 col-lg-4">
            <p class="fw-semibold text-center">N/A</p>
          </div>
        </div>
        <hr class="mt-0" />
        @for (
          question of professionalismRatings
            | keyvalue: keyValuePairDefaultOrder;
          track question
        ) {
          <div class="row justify-content-center align-items-start py-1">
            <div class="col-12 col-lg-4">
              <p class="text-left">{{ question.key }}</p>
            </div>
            <div class="col-12 col-lg-4">
              <app-star-rating
                [rating]="question.value.value || 0"
                [size]="14"
                [readonly]="readOnly"
                (updatedRating)="updateRating($event, question)"
              ></app-star-rating>
            </div>
            <div class="col-12 col-lg-4 d-flex flex-column align-items-center">
              <input
                type="checkbox"
                class="form-check-input"
                [disabled]="readOnly"
                (click)="onNAChange(question)"
                [checked]="question.value.na"
              />
            </div>
          </div>
        }
        @if (showOverallRatings) {
          <div class="row">
            <div class="col-12 col-lg-4">
              <p class="text-decoration-underline fw-semibold">
                Overall Professionalism Rating
              </p>
            </div>
            <div class="col-12 col-lg-4">
              <app-star-rating
                [rating]="overallProfessionalismRating"
                [size]="14"
              ></app-star-rating>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
